import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import * as ScreenText from "../../consts/ScreenText.js";

export default function DialogForm({ open, handleClose, save, titleDialog }) {
  const [input, setInput] = React.useState({});

  const handleInputChange = (event) => {
    const { value } = event.target;
    setInput(value);
  };

  const localSave = () => {
    save(input);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{titleDialog}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {ScreenText.ABM_CATEGORIES_DIALOG_MESSAGE}{" "}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Nombre"
            fullWidth
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {ScreenText.ABM_CATEGORIES_BUTTON_CANCEL}
          </Button>
          <Button onClick={localSave} color="primary">
            {ScreenText.ABM_CATEGORIES_BUTTON_ADD}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
